module.exports = __webpack_public_path__ + "img/d20-centered.6370df50.svg";